var _rect, _path, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlanningAdd(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.64062,
    y: 0.75,
    width: 11.5,
    height: 11.5,
    rx: 1.25,
    fill: "#E6ECF6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.89079 6.91666H7.80745V9C7.80745 9.22916 7.61995 9.41666 7.39079 9.41666C7.16162 9.41666 6.97412 9.22916 6.97412 9V6.91666H4.89079C4.66162 6.91666 4.47412 6.72916 4.47412 6.5C4.47412 6.27083 4.66162 6.08333 4.89079 6.08333H6.97412V3.99999C6.97412 3.77083 7.16162 3.58333 7.39079 3.58333C7.61995 3.58333 7.80745 3.77083 7.80745 3.99999V6.08333H9.89079C10.12 6.08333 10.3075 6.27083 10.3075 6.5C10.3075 6.72916 10.12 6.91666 9.89079 6.91666Z",
    fill: "#606F8B"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.64062,
    y: 0.75,
    width: 11.5,
    height: 11.5,
    rx: 1.25,
    stroke: "#E6ECF6",
    strokeWidth: 1.5
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlanningAdd);
export default __webpack_public_path__ + "static/media/planning_add.2378ddc153b96842df1e98f34e01935e.svg";
export { ForwardRef as ReactComponent };